(function () {
  const root = document.getElementById('cut-wizard-json-generator');
  if (!root) return;

  const els = {
    import: root.querySelector('[data-cjwg-import]'),
    load: root.querySelector('[data-cjwg-load-json]'),
    steps: root.querySelector('[data-cjwg-steps]'),
    addStep: root.querySelector('[data-cjwg-add-step]'),
    out: root.querySelector('[data-cjwg-output]'),
    copy: root.querySelector('[data-cjwg-copy]'),
    download: root.querySelector('[data-cjwg-download]'),
    status: root.querySelector('[data-cjwg-status]'),
  };

  let stepCounter = 0;

  function dollarsToCents(str) {
    const n = parseFloat(String(str).replace(/,/g, '').trim());
    if (!Number.isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function centsToDollarsInput(cents) {
    const c = Number(cents) || 0;
    if (c === 0) return '0';
    const d = c / 100;
    return Number.isInteger(d) ? String(d) : d.toFixed(2);
  }

  function gatherState() {
    const stepEls = root.querySelectorAll('[data-cjwg-step]');
    const steps = [];
    let si = 0;
    stepEls.forEach((stepEl) => {
      const heading = stepEl.querySelector('[data-cjwg-step-heading]')?.value?.trim() || '';
      const duplicateForFull = stepEl.querySelector('[data-cjwg-dup-full]')?.checked ?? true;
      const optionRows = stepEl.querySelectorAll('[data-cjwg-option]');
      const options = [];
      optionRows.forEach((row) => {
        const label = row.querySelector('[data-cjwg-opt-label]')?.value?.trim() || '';
        const dollars = row.querySelector('[data-cjwg-opt-extra]')?.value ?? '0';
        if (!label) return;
        options.push({ label, extra_cents: dollarsToCents(dollars) });
      });
      if (!heading && options.length === 0) return;
      const step = {
        heading: heading || `Part ${si + 1}`,
        options,
      };
      if (!duplicateForFull) step.duplicate_for_full = false;
      steps.push(step);
      si++;
    });
    return { steps };
  }

  function buildJson() {
    const data = gatherState();
    if (!data.steps.length) {
      return { ok: false, error: 'Add at least one part with a heading and one option label.' };
    }
    for (let i = 0; i < data.steps.length; i++) {
      if (!data.steps[i].options.length) {
        return { ok: false, error: `Part ${i + 1} (“${data.steps[i].heading}”) needs at least one option with a label.` };
      }
    }
    return { ok: true, json: JSON.stringify({ steps: data.steps }, null, 2) };
  }

  function setStatus(msg, kind) {
    if (!els.status) return;
    els.status.textContent = msg || '';
    els.status.className = 'cjwg__status' + (kind === 'ok' ? ' cjwg__status--ok' : kind === 'err' ? ' cjwg__status--err' : '');
  }

  function refreshOutput() {
    const r = buildJson();
    if (!r.ok) {
      els.out.value = '';
      setStatus(r.error, 'err');
      return;
    }
    els.out.value = r.json;
    setStatus('Valid JSON. Paste into product metafield custom.cut_wizard (JSON).', 'ok');
  }

  function escapeAttr(s) {
    return String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function optionRowHtml(label, extraDollars) {
    const lab = escapeAttr(label ?? '');
    const ex = escapeAttr(extraDollars != null ? String(extraDollars) : '0');
    return `
      <div class="cjwg-option" data-cjwg-option>
        <input type="text" class="cjwg__input cjwg__input--grow" data-cjwg-opt-label placeholder="Option label" value="${lab}" autocomplete="off">
        <span class="cjwg-muted">+$</span>
        <input type="text" class="cjwg__input cjwg__input--narrow" data-cjwg-opt-extra placeholder="0" inputmode="decimal" value="${ex}" autocomplete="off">
        <button type="button" class="cjwg__btn" data-cjwg-remove-option aria-label="Remove option">×</button>
      </div>
    `;
  }

  function stepHtml(id, heading, optionsRowsHtml) {
    const h = escapeAttr(heading ?? '');
    const opts = optionsRowsHtml || optionRowHtml('', '0');
    return `
      <div class="cjwg-step" data-cjwg-step data-step-id="${id}">
        <div class="cjwg-step__top">
          <span class="cjwg-muted">Heading</span>
          <input type="text" class="cjwg__input cjwg__input--grow" data-cjwg-step-heading placeholder="e.g. Shoulder" value="${h}" autocomplete="off">
          <button type="button" class="cjwg__btn" data-cjwg-remove-step>Remove part</button>
        </div>
        <div class="cjwg__row cjwg__row--tight">
          <label class="cjwg-muted" style="display:flex;align-items:center;gap:0.35rem;">
            <input type="checkbox" data-cjwg-dup-full checked>
            Duplicate for full
          </label>
        </div>
        <div class="cjwg-options" data-cjwg-option-list>${opts}</div>
        <div class="cjwg__row cjwg__row--tight">
          <button type="button" class="cjwg__btn" data-cjwg-add-option>+ Option</button>
        </div>
      </div>
    `;
  }

  function bindOptionList(list) {
    if (!list) return;
    list.querySelectorAll('[data-cjwg-option]').forEach((row) => {
      if (row.dataset.cjwgBound) return;
      row.dataset.cjwgBound = '1';
      row.querySelector('[data-cjwg-remove-option]')?.addEventListener('click', () => {
        if (list.querySelectorAll('[data-cjwg-option]').length <= 1) return;
        row.remove();
        refreshOutput();
      });
      row.querySelectorAll('[data-cjwg-opt-label], [data-cjwg-opt-extra]').forEach((inp) => {
        inp.addEventListener('input', refreshOutput);
      });
    });
  }

  function bindStep(stepEl) {
    stepEl.querySelector('[data-cjwg-remove-step]')?.addEventListener('click', () => {
      stepEl.remove();
      refreshOutput();
    });
    stepEl.querySelector('[data-cjwg-add-option]')?.addEventListener('click', () => {
      const list = stepEl.querySelector('[data-cjwg-option-list]');
      list?.insertAdjacentHTML('beforeend', optionRowHtml('', '0'));
      bindOptionList(list);
      refreshOutput();
    });
    stepEl.querySelector('[data-cjwg-step-heading]')?.addEventListener('input', refreshOutput);
    stepEl.querySelector('[data-cjwg-dup-full]')?.addEventListener('change', refreshOutput);
    bindOptionList(stepEl.querySelector('[data-cjwg-option-list]'));
  }

  function appendStep(heading, options, duplicateForFull = true) {
    stepCounter += 1;
    const id = `s${stepCounter}`;
    let optsHtml = '';
    if (options && options.length) {
      options.forEach((o) => {
        optsHtml += optionRowHtml(o.label, centsToDollarsInput(o.extra_cents));
      });
    } else {
      optsHtml = optionRowHtml('', '0');
    }
    els.steps.insertAdjacentHTML('beforeend', stepHtml(id, heading || '', optsHtml));
    const stepEl = els.steps.querySelector(`[data-step-id="${id}"]`);
    if (stepEl) {
      const cb = stepEl.querySelector('[data-cjwg-dup-full]');
      if (cb) cb.checked = !!duplicateForFull;
      bindStep(stepEl);
    }
  }

  function clearSteps() {
    els.steps.innerHTML = '';
    stepCounter = 0;
  }

  function loadFromJsonText(text) {
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      setStatus('Invalid JSON: ' + (e.message || 'parse error'), 'err');
      return;
    }
    const steps = data && Array.isArray(data.steps) ? data.steps : null;
    if (!steps || !steps.length) {
      setStatus('JSON must include a non-empty "steps" array.', 'err');
      return;
    }
    for (let i = 0; i < steps.length; i++) {
      const st = steps[i];
      if (!st || typeof st.heading !== 'string' || !Array.isArray(st.options)) {
        setStatus(`Step ${i + 1} must have "heading" (string) and "options" (array).`, 'err');
        return;
      }
      if (!st.heading.trim()) {
        setStatus(`Step ${i + 1}: "heading" cannot be empty.`, 'err');
        return;
      }
      if (!st.options.length) {
        setStatus(`Step ${i + 1}: need at least one option.`, 'err');
        return;
      }
      for (let j = 0; j < st.options.length; j++) {
        const op = st.options[j];
        if (!op || typeof op.label !== 'string') {
          setStatus(`Step ${i + 1}, option ${j + 1}: missing "label".`, 'err');
          return;
        }
        if (op.extra_cents != null && typeof op.extra_cents !== 'number') {
          setStatus(`Step ${i + 1}, option ${j + 1}: "extra_cents" must be a number (cents).`, 'err');
          return;
        }
      }
    }
    clearSteps();
    steps.forEach((st) => {
      const opts = st.options.map((o) => ({
        label: o.label,
        extra_cents: typeof o.extra_cents === 'number' ? o.extra_cents : 0,
      }));
      const dup = st.duplicate_for_full !== false;
      appendStep(st.heading, opts, dup);
    });
    refreshOutput();
    setStatus('Loaded ' + steps.length + ' part(s).', 'ok');
  }

  els.load?.addEventListener('click', () => {
    const text = (els.import?.value || '').trim();
    if (!text) {
      setStatus('Paste JSON first.', 'err');
      return;
    }
    loadFromJsonText(text);
  });

  els.addStep?.addEventListener('click', () => {
    appendStep('', null);
    refreshOutput();
  });

  els.copy?.addEventListener('click', async () => {
    refreshOutput();
    const t = els.out.value;
    if (!t) return;
    try {
      await navigator.clipboard.writeText(t);
      setStatus('Copied.', 'ok');
    } catch {
      els.out.select();
      setStatus('Select output and copy manually.', 'err');
    }
  });

  els.download?.addEventListener('click', () => {
    refreshOutput();
    const t = els.out.value;
    if (!t) return;
    const blob = new Blob([t], { type: 'application/json;charset=utf-8' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'cut-wizard.json';
    a.click();
    URL.revokeObjectURL(a.href);
    setStatus('Downloaded.', 'ok');
  });

  appendStep('', null);
  refreshOutput();
})();
